<template>
  <modal :show="show" @close="close">
    <div class="modal-body">
      <label class="form-label">
        {{message}}
      </label>
    </div>
    <div class="modal-footer text-right">
      <button class="modal-default-button" @click="yes()">
        Yes
      </button>
      <button class="modal-default-button" @click="no()">
        No
      </button>
    </div>
  </modal>
</template>

<script>
import Modal from "./Modal.vue"

export default {
  name: "ModalYesNo",
  components: { Modal },
  props: ["show", "message"],
  methods: {
    close: function() {
      this.$emit("close")
    },
    yes: function() {
      this.$emit("yes")
      this.close()
    },
    no: function() {
      // Some save logic goes here...

      this.close()
    }
  }
}
</script>

<style scoped>
.modal-header h3 {
  margin-top: 0;
  color: #42b983;
}

.modal-body {
  margin: 20px 0;
  font-size: 1.5rem;
}

.modal-default-button {
    margin: 1rem 0.5rem;
    padding: 0.5rem 2rem;
    background-color: #F5F5F5;
    border: 0;
    border-radius: 5px;
    cursor: pointer;
}

.modal-default-button:hover {
    background-color: #E1E1E1;
}

.modal-default-button:last-child {
  margin-right:0;
}

.text-right {
  text-align: right;
}

.form-label {
  display: block;
  margin-bottom: 1em;
}

.form-label > .form-control {
  margin-top: 0.5em;
}

.form-control {
  display: block;
  width: 100%;
  padding: 0.5em 1em;
  line-height: 1.5;
  border: 1px solid #ddd;
}
</style>
